import script from "./AppLegalFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLegalFooter.vue?vue&type=script&setup=true&lang=js"

import "./AppLegalFooter.vue?vue&type=style&index=0&id=651de106&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-651de106"]])

export default __exports__